export default function($) {
  const days = $('.js-festival-day-filter'),
        cards = $('.js-festival-card');

  days.each(function(){
    if ( $(this).data('day') == 'all' ) {
      $(this).find('.js-festival-day-checked').removeClass('hidden')
      $(this).find('.js-festival-day-checked').addClass('block')
    }
  })

  days.on('click', function() {
    let daySelected = $(this).data('day');

    if (daySelected == "all") {
      cards.removeClass('hidden')
      cards.addClass('block')
    } else {
      cards.each( function() {
        let cardDays = $(this).data('days');

        if (cardDays.indexOf("all") >= 0 || cardDays.indexOf(daySelected) >= 0) {
          $(this).removeClass('hidden')
          $(this).addClass('block')
        } else {
          $(this).removeClass('block')
          $(this).addClass('hidden')
        }
      })
    }


    $('.js-festival-day-checked').addClass('hidden')
    $(this).find('.js-festival-day-checked').removeClass('hidden')
    $(this).find('.js-festival-day-checked').addClass('block')
  })
}
